import { Match2Reward } from '../match2/rewards/match2-rewards.ruleset';
import { duration } from '../utils/duration';

export const resurrectionRewards: Match2Reward[] = [
  {
    type: 'energy',
    duration: duration({ hours: 5 }),
  },
  {
    type: 'powerups',
    subType: 'bomb',
    duration: duration({ hours: 1 }),
  },
  {
    type: 'powerups',
    subType: 'rocket',
    duration: duration({ hours: 1 }),
  },
  {
    type: 'boosters',
    subType: 'dart',
    amount: 1,
  },
  {
    type: 'boosters',
    subType: 'bullet',
    amount: 1,
  },
  {
    type: 'boosters',
    subType: 'drill',
    amount: 1,
  },
  {
    type: 'boosters',
    subType: 'roulette',
    amount: 1,
  },
];

/**
 * Duration after which the resurrection offer expires
 */
export const resurrectionExpiration = duration({ days: 30 });

/**
 * Gems reward granted upon resurrection
 */
export const resurrectionHundredGemsReward: Match2Reward = {
  type: 'gems',
  amount: 100,
};

/**
 * Gems reward granted upon migration ToS acceptance
 */
export const resurrectionMigrationGemsReward: Match2Reward = {
  type: 'gems',
  amount: 200,
};

/**
 * 50-gem apology reward granted with the 2026-04-28 resurrection OAs
 */
export const resurrectionFiftyGemsReward: Match2Reward = {
  type: 'gems',
  amount: 50,
};
